var _class;
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import { action } from '@ember/object';
import Component from '@glimmer/component';
let UiPagination = (_class = class UiPagination extends Component {
  get hasPreviousPage() {
    return this.args.pageNumber > 1;
  }
  get end() {
    if (this.isLastPage) {
      return this.start + this.lastPageSize - 1;
    } else {
      return this.start + this.args.pageSize - 1;
    }
  }
  get isLastPage() {
    return this.args.pageCount === 0 || this.args.pageNumber === this.args.pageCount;
  }
  get hasNextPage() {
    return this.args.pageNumber < this.args.pageCount;
  }
  get lastPageSize() {
    const recordCount = this.args.recordCount;
    const pageSize = this.args.pageSize;
    const remainder = recordCount % pageSize;
    if (remainder === 0) {
      return pageSize;
    } else {
      return remainder;
    }
  }
  get nextPageNumber() {
    return this.args.pageNumber + 1;
  }
  get previousPageNumber() {
    const previousPageNumber = this.args.pageNumber - 1;
    if (previousPageNumber > 0) {
      return previousPageNumber;
    } else {
      return 1;
    }
  }
  get start() {
    const pageNumber = this.args.pageNumber;
    const pageSize = this.args.pageSize;
    return pageNumber * pageSize - pageSize + 1;
  }
  goToNextPage() {
    const hasNextPage = this.hasNextPage;
    const nextPageNumber = this.nextPageNumber;
    if (hasNextPage) {
      this.args.setPageNumber(nextPageNumber);
    }
  }
  goToPreviousPage() {
    const hasPreviousPage = this.hasPreviousPage;
    const previousPageNumber = this.previousPageNumber;
    if (hasPreviousPage) {
      this.args.setPageNumber(previousPageNumber);
    }
  }
}, (_applyDecoratedDescriptor(_class.prototype, "goToNextPage", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToNextPage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToPreviousPage", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToPreviousPage"), _class.prototype)), _class);
export { UiPagination as default };